module.exports = __webpack_public_path__ + "img/backspace-fill.b22ed71c.svg";